import { render, staticRenderFns } from "./Loginphone.vue?vue&type=template&id=48c7cbcf&"
import script from "./Loginphone.vue?vue&type=script&lang=js&"
export * from "./Loginphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports